
import api from './api';

// Types for auth responses
interface LoginResponse {
  token: string;
  user: {
    id: number;
    username: string;
    role: string;
  };
}

export const authService = {
  // Login user
  login: async (username: string, password: string): Promise<LoginResponse> => {
    try {
      // Try to connect to the real API first
      const response = await api.post('/auth/login', { username, password });
      
      // Store token and user in localStorage
      localStorage.setItem('auth_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.user));
      
      return response.data;
    } catch (error: any) {
      // Handle network errors in development with mock data for the default admin
      if (error.code === 'ERR_NETWORK' && (import.meta.env.DEV || import.meta.env.MODE === 'development')) {
        if (username === 'admin' && password === 'admin123') {
          console.warn('Using mock admin login due to network error. In production, this would fail.');
          
          // Create mock admin response
          const mockResponse = {
            token: 'mock-jwt-token-for-development-only',
            user: {
              id: 1,
              username: 'admin',
              role: 'admin'
            }
          };
          
          // Store mock data in localStorage
          localStorage.setItem('auth_token', mockResponse.token);
          localStorage.setItem('admin_user', JSON.stringify(mockResponse.user));
          
          return mockResponse;
        }
      }
      
      // For any other error or login failure, throw the error
      console.error('Error during login:', error);
      throw error;
    }
  },
  
  // Logout user
  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('admin_user');
  },
  
  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    return localStorage.getItem('auth_token') !== null;
  },
  
  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  },

  // Verify token
  verifyToken: async () => {
    try {
      // First try to verify with the server
      const response = await api.get('/auth/verify');
      return response.data;
    } catch (error: any) {
      // If there's a network error in development, allow mock auth to continue
      if (error.code === 'ERR_NETWORK' && (import.meta.env.DEV || import.meta.env.MODE === 'development')) {
        const user = authService.getCurrentUser();
        if (user?.username === 'admin' && user?.role === 'admin') {
          console.warn('Using mock token verification due to network error.');
          return { user };
        }
      }
      
      console.error('Token verification failed:', error);
      // Clear invalid tokens
      localStorage.removeItem('auth_token');
      localStorage.removeItem('admin_user');
      throw error;
    }
  }
};
